import createClient from '../../helpers/api-client';

const storeSuffix = 'SendMail';

// ACTIONS
export const SEND_MEMBERSHIP_MAIL = `sendMembershipMailAction${storeSuffix}`;

// MUTATIONS
//send mutations
export const BEGIN_SEND = `beginSendMutation${storeSuffix}`;
export const SEND_COMPLETED = `sendCompletedMutation${storeSuffix}`;
export const SEND_ERROR = `sendErrorMutation${storeSuffix}`;

// GETTERS
export const GET_SEND_ERROR = `getSendErrorGetter${storeSuffix}`;

export const modelState = () => ({
    sendMail: {
        sendErrors: {
            sendMembership: null,
        },
    },
});

export const actions = {
    [SEND_MEMBERSHIP_MAIL]: ({ state, commit }, form) => {
        return new Promise(async (resolve, reject) => {
            const apiClient = createClient(state);

            commit(BEGIN_SEND, 'sendMembership');

            try {
                const res = await apiClient.post('/api/send-membership', form);
                commit(SEND_COMPLETED, 'sendMembership');

                resolve(res);
            } catch (error) {
                console.log('error', error);
                let message = 'Ett fel har inträffat. Var vänligt försök igen';

                commit(SEND_ERROR, 'sendMembership', message);
                reject(error);
            }
        });
    },
};

export const mutations = {
    [BEGIN_SEND]: (state, key) => {
        state.sendMail.sendErrors[key] = null;
    },
    [SEND_COMPLETED]: (state, key) => {
        state.sendMail.sendErrors[key] = null;
    },
    [SEND_ERROR]: (state, { key, payload }) => {
        state.sendMail.sendErrors[key] = payload;
    },
};

export const getters = {
    [GET_SEND_ERROR]: state => {
        return key => {
            return state.sendMail.sendErrors[key];
        };
    },
};



// WEBPACK FOOTER //
// ./src/store/store-models/send-mail-model.js